import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'faqSearch',
  standalone: false,
})
export class FAQSearchPipe implements PipeTransform {
  transform(items: any[], searchText: string): any[] {
    if (!items) {
      return [];
    }
    if (!searchText) {
      return items;
    }
    searchText = searchText.toLowerCase();
    return items.filter(
      item => item.question.toLowerCase().includes(searchText) || item.answer.toLowerCase().includes(searchText)
    );
  }
}
